export default __webpack_public_path__ + "static/media/image1pro3.90b301bf.jpeg";